import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { EmailLink, NameHeading, PhoneLink } from '../../common';
import { toHref } from '../../../util/helpers';
import { formatAddress } from '../../../util/helpers';

const Wrapper = styled.div`
  margin-bottom: 1em;
`;

function SpecialistDetails({
  addressState,
  city,
  email,
  fax,
  firstName,
  lastName,
  phoneExtension,
  practiceName,
  primaryPhoneNumber,
  secondaryStreetAddress,
  streetAddress,
  type,
  url,
  zipCode,
  notes,
}) {
  return (
    <Wrapper>
      <NameHeading>
        {`${firstName} ${lastName}`} {type && `, ${type}`}
      </NameHeading>
      <div>{practiceName}</div>
      <div>{streetAddress}</div>
      <div>{secondaryStreetAddress}</div>
      <div>{formatAddress(city, addressState, zipCode)}</div>
      {primaryPhoneNumber && (
        <PhoneLink
          ext={phoneExtension}
          label="Phone"
          tel={primaryPhoneNumber}
        />
      )}
      {fax && <PhoneLink label="Fax" tel={fax} />}
      {email && <EmailLink label="Email" mailto={email} />}
      {url && (
        <div>
          Website:{' '}
          <a href={toHref(url)} target="_blank">
            {url}
          </a>
        </div>
      )}
      {notes && (
        <div>
          {<span>Notes: </span>}
          {notes}
        </div>
      )}
    </Wrapper>
  );
}

SpecialistDetails.propTypes = {
  addressState: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  primaryPhoneNumber: PropTypes.string.isRequired,
  streetAddress: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  zipCode: PropTypes.string.isRequired,
  email: PropTypes.string,
  fax: PropTypes.string,
  notes: PropTypes.string,
  phoneExtension: PropTypes.string,
  practiceName: PropTypes.string,
  secondaryStreetAddress: PropTypes.string,
  url: PropTypes.string,
};

SpecialistDetails.defaultProps = {
  email: '',
  fax: '',
  notes: '',
  practiceName: '',
  secondaryStreetAddress: '',
};

export default SpecialistDetails;



// WEBPACK FOOTER //
// ./src/modules/SpecialistPage/components/SpecialistDetails.js